// FILE: /src/Components/Assets/Toolbar.js (FULLY UPDATED)

import React, { useRef } from 'react';
import { Button, Tooltip, Spin, Progress } from 'antd';
import { UploadOutlined, AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { formatBytes } from '../../utils/formatters';
import { useSelector } from 'react-redux';

const Toolbar = ({ onFileUpload, isUploading, totalSize, viewMode, setViewMode, onSelectAll, areAllSelected, hasAssets }) => {
  const fileInputRef = useRef(null);
  
  const { subscription } = useSelector(state => state.subscription);
  
  const storageLimitGB = subscription?.plan?.storage_gb_limit ?? 5; 
  
  const storageLimitBytes = storageLimitGB * 1024 * 1024 * 1024;
  const usagePercentage = storageLimitBytes > 0 ? Math.min((totalSize / storageLimitBytes) * 100, 100) : 0;

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      onFileUpload(event.target.files);
    }
    event.target.value = null;
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 p-4 mb-4 bg-white rounded-lg shadow-sm border">
      <div className="flex items-center gap-2">
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
          disabled={isUploading}
          multiple
          // --- THIS IS THE FIX: Add document types to the accept attribute ---
          accept="image/jpeg,image/png,image/webp,image/gif,video/mp4,video/quicktime,application/pdf,.docx,.pptx"
          // --- END OF FIX ---
        />
        <Button 
          type="primary" 
          icon={isUploading ? <Spin size="small" /> : <UploadOutlined />} 
          onClick={handleUploadClick}
          disabled={isUploading}
        >
          {isUploading ? 'Uploading...' : 'Upload'}
        </Button>
        {hasAssets && (
          <Button onClick={onSelectAll}>
            {areAllSelected ? 'Deselect All' : 'Select All'}
          </Button>
        )}
      </div>
      <div className="flex items-center gap-4 flex-wrap flex-grow md:flex-grow-0">
        <div className="text-sm text-gray-600 font-medium w-full md:w-auto">
          <div className="flex justify-between">
            <span>Storage Used</span>
            <span>{formatBytes(totalSize)} / {storageLimitGB} GB</span>
          </div>
          <Progress percent={usagePercentage} showInfo={false} size="small" />
        </div>
        <div className="flex items-center border border-gray-300 rounded-md p-0.5 bg-gray-100">
          <Tooltip title="Grid View">
            <Button 
              type={viewMode === 'grid' ? 'primary' : 'text'}
              icon={<AppstoreOutlined />} 
              onClick={() => setViewMode('grid')}
            />
          </Tooltip>
          <Tooltip title="List View">
            <Button 
              type={viewMode === 'list' ? 'primary' : 'text'}
              icon={<UnorderedListOutlined />}
              onClick={() => setViewMode('list')}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Toolbar;